import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Phone, Menu, X, ArrowRight } from "lucide-react";
import { CONTACT, NAV_LINKS } from "@/data/content";

export const Header = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 inset-x-0 z-50 bg-white transition-shadow duration-300 ${scrolled ? "shadow-md" : "border-b border-slate-200"}`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8 flex items-center justify-between h-20">
        <Link to="/" data-testid="header-logo" className="flex items-center gap-3 shrink-0">
          <img src={CONTACT.logo} alt="Elite Facility Solutions" className="h-12 w-auto" />
        </Link>

        <nav className="hidden lg:flex items-center gap-9">
          {NAV_LINKS.map((l) =>
            l.href.startsWith("/") ? (
              <Link
                key={l.href}
                to={l.href}
                data-testid={`nav-${l.label.toLowerCase()}`}
                className="text-sm font-semibold text-slate-700 hover:text-[#1c4f9c] transition-colors duration-200"
              >
                {l.label}
              </Link>
            ) : (
              <a
                key={l.href}
                href={l.href}
                data-testid={`nav-${l.label.toLowerCase()}`}
                className="text-sm font-semibold text-slate-700 hover:text-[#1c4f9c] transition-colors duration-200"
              >
                {l.label}
              </a>
            )
          )}
        </nav>

        <div className="hidden lg:flex items-center gap-3">
          <a
            href={CONTACT.phoneHref}
            data-testid="header-call-btn"
            className="inline-flex items-center gap-2 border-2 border-[#1c4f9c] text-[#1c4f9c] font-bold text-sm py-2.5 px-5 rounded-sm hover:bg-[#1c4f9c] hover:text-white transition-colors duration-200"
          >
            <Phone size={16} strokeWidth={2.5} />
            {CONTACT.phone}
          </a>
          <a
            href="#contact"
            data-testid="header-estimate-btn"
            className="inline-flex items-center gap-2 bg-[#e02329] text-white font-bold text-sm py-2.5 px-5 rounded-sm hover:bg-[#c81e24] transition-colors duration-200"
          >
            Free Estimate
            <ArrowRight size={16} strokeWidth={2.5} />
          </a>
        </div>

        <button
          data-testid="mobile-menu-toggle"
          onClick={() => setOpen(!open)}
          className="lg:hidden text-[#1c4f9c]"
          aria-label="Menu"
        >
          {open ? <X size={28} /> : <Menu size={28} />}
        </button>
      </div>

      {open && (
        <div data-testid="mobile-menu" className="lg:hidden bg-white border-t border-slate-200 px-6 py-5 space-y-4">
          {NAV_LINKS.map((l) =>
            l.href.startsWith("/") ? (
              <Link key={l.href} to={l.href} onClick={() => setOpen(false)} className="block text-base font-semibold text-slate-700">
                {l.label}
              </Link>
            ) : (
              <a key={l.href} href={l.href} onClick={() => setOpen(false)} className="block text-base font-semibold text-slate-700">
                {l.label}
              </a>
            )
          )}
          <a
            href={CONTACT.phoneHref}
            className="inline-flex items-center gap-2 bg-[#e02329] text-white font-bold text-sm py-3 px-6 rounded-sm w-full justify-center"
          >
            <Phone size={16} /> {CONTACT.phone}
          </a>
        </div>
      )}
    </header>
  );
};
